import axios from "axios";
import hash from "object-hash";

class Request {
  defaults: object = {
    withCredentials: true,
    data: null,
    method: "post",
    responseType: "json",
    headers: {
      "Content-Type": "application/json" // "multipart/form-data",
    },
    url: ""
  };

  cache: object = {};
  cacheTTL: number = 5000;

  constructor() {
    return this;
  }

  request(data: any): any {
    const config = {
      ...this.defaults,
      ...data
    };

    this.garbageCollection();

    const cacheKey = hash(config);
    let cached = (this.cache as any)[cacheKey] || false;

    if (
      (config.data && config.data.reload) ||
      (config.params && config.params.reload)
    ) {
      cached = false;
      delete (this.cache as any)[cacheKey];
    }

    if (!cached) {
      const request = axios(config).catch((e: any) => console.log(e));
      if (config.method == "get") {
        let ttl = this.cacheTTL;
        if (config.data && config.data.ttl) {
          ttl = config.data.ttl;
        }
        if (config.params && config.params.ttl) {
          ttl = config.params.ttl;
        }

        (this.cache as any)[cacheKey] = {
          request,
          timestamp: new Date().getTime(),
          ttl
        };
      }
      return request;
    } else {
      return cached.request;
    }
  }

  save(url: string, data: object, config: object) {
    if ((data as any).id) {
      this.put(url, data, config);
    } else {
      this.post(url, data, config);
    }
  }

  get(url: string, data: object = {}, config: object = {}) {
    return this.request({
      url,
      method: "get",
      params: data,
      ...config
    }).then((res: object) => this.defaultResolver(res));
  }

  getList(url: string, data: object = {}, config: object = {}) {
    return this.request({
      url,
      method: "get",
      params: data,
      ...config
    }).then((res: object) => this.defaultResolver(res));
  }

  put(url: string, data: object = {}, config: object = {}) {
    return this.request({
      url,
      method: "put",
      data,
      ...config
    }).then((res: object) => this.defaultResolver(res));
  }

  delete(url: string, data: object = {}, config: object = {}) {
    return this.request({
      url,
      method: "delete",
      data,
      ...config
    }).then((res: object) => this.defaultResolver(res));
  }

  post(url: string, data: object = {}, config: object = {}) {
    return this.request({
      url,
      method: "post",
      data,
      ...config
    }).then((res: object) => this.defaultResolver(res));
  }

  defaultResolver(response: object) {
    return new Promise((resolve, reject) => {
      if (response && (response as any).status == 200) {
        resolve((response as any).data);
      } else {
        reject(new Error("Could not connect to endpoint"));
      }
    });
  }

  responseOne(response: object) {
    if ((response as any).data.success) {
      return (response as any).data.object;
    }
  }

  responseCollection(response: object) {
    if ((response as any).data.success) {
      return (response as any).data.results;
    }
  }

  garbageCollection() {
    // const self = this;
    Object.keys(this.cache).forEach(key => {
      if (
        new Date().getTime() - (this as any).cache[key].timestamp >
        (this as any).cache[key].ttl
      ) {
        delete (this as any).cache[key];
      }
    });
  }
}

const request = new Request();

export default request;
